module.exports = __webpack_public_path__ + "static/media/seven.992e9098.svg";